var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageSectionOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-background",
    d: "M6 0.5H18C18.8239 0.5 19.5 1.17614 19.5 2V14C19.5 14.8239 18.8239 15.5 18 15.5H6C5.17614 15.5 4.5 14.8239 4.5 14V2C4.5 1.17614 5.17614 0.5 6 0.5ZM10.1809 9.07124C9.78125 8.53321 8.97982 8.53292 8.57971 9.07038L7.20145 10.8981C7.20127 10.8983 7.20108 10.8986 7.20089 10.8988C6.69169 11.5721 7.19492 12.5 8.01 12.5H16.01C16.8244 12.5 17.3125 11.565 16.8093 10.8991C16.8091 10.8988 16.8088 10.8984 16.8085 10.8981L14.4318 7.73239C14.4314 7.73189 14.431 7.73138 14.4307 7.73089C14.0308 7.19302 13.2292 7.19304 12.8293 7.73094C12.8289 7.73142 12.8286 7.7319 12.8282 7.73239L11.0006 10.1664L10.1818 9.07239C10.1815 9.072 10.1812 9.07162 10.1809 9.07124Z",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M1 4C0.45 4 0 4.45 0 5V18C0 19.1 0.9 20 2 20H15C15.55 20 16 19.55 16 19C16 18.45 15.55 18 15 18H2V5C2 4.45 1.55 4 1 4Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSectionOutlinedIcon);
export default __webpack_public_path__ + "static/media/imageSectionOutlinedIcon.0de7c8a7.svg";
export { ForwardRef as ReactComponent };